import { sizes, spacings } from "@/assets/themes";
import { Block, Container, PrivateJobberBanner, Spinner } from "@/components";
import { setAddressInitialValues } from "@/utils";
import { Form, Formik } from "formik";
import { useState } from "react";
import { HashRouter } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import * as yup from "yup";
import polyglot from "@/utils/polyglot";

// Import our split components
import RepeatFlow from "./RepeatFlow";

const Layout = ({ pages, onSubmit, isLoading, initialValues, data }) => {
  const privateJobberId = new URLSearchParams(window.location.search).get(
    "jobber_id"
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSteps, setActiveSteps] = useState([0]);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  const handleStepChange = (step, routerHistory) => {
    if (step < 0) {
      routerHistory.replace({
        pathname: pages[activeIndex].path,
        state: routerHistory.location.state,
      });
    } else {
      setActiveIndex(step);
      if (!activeSteps.includes(step)) setActiveSteps((n) => [...n, step]);
    }
  };

  return (
    <Block
      marginTop={spacings.ml}
      marginBottom={`calc(${sizes.size54} + ${spacings.xl})`}
      paddingBottom={spacings.l}
    >
      {pages.length > 0 ? (
        <Formik
          initialValues={{
            private_jobber_id: privateJobberId,
            start_date: "",
            frequency: "",
            start_hour: "",
            end_hour: "",
            auto_payment: null,
            category: null,
            title: "",
            nb_hours: 1,
            ...setAddressInitialValues(),
            ...initialValues,
            // ...setPaymentInitialValues(data),
          }}
          enableReinitialize
          validateOnMount
          onSubmit={handleSubmit}
          validationSchema={() => {
            if (pages[activeIndex]) {
              return yup.lazy(() => pages[activeIndex].validationSchema);
            }
            return yup.lazy(() => pages[0].validationSchema);
          }}
        >
          {({ values }) => (
            <Form>
              <HashRouter>
                <Redirect to={pages[0].path} />
                <Container.XSmall>
                  {data?.jobber &&
                    values.private_jobber_id &&
                    pages[activeIndex].path !== "jobber" && (
                      <PrivateJobberBanner
                        id={values.private_jobber_id}
                        jobbers={[data.jobber]}
                        title={polyglot.t("jobs.selected_jobber")}
                      />
                    )}
                  <RepeatFlow
                    pages={pages}
                    onChange={handleStepChange}
                    activeIndex={activeIndex}
                    isLoading={isLoading}
                  />
                </Container.XSmall>
              </HashRouter>
            </Form>
          )}
        </Formik>
      ) : (
        <Block
          display="flex"
          alignItems="center"
          justifyContent="center"
          padding={spacings.l}
        >
          <Spinner.Medium brand />
        </Block>
      )}
    </Block>
  );
};

export default Layout;
